export const Notice = () => {
  return (
    <div className='text-center body-xxs sm:body-xs text-gray-700 relative -top-3 sm:-top-1'>
      AskNeedl can make mistakes. Double-check important info.
    </div>
  );
};
